import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/lib/locale/pt";
import en from "vuetify/lib/locale/en";

import "@mdi/font/css/materialdesignicons.css";
import "@flaticon/flaticon-uicons/css/bold/all.css";
import "@flaticon/flaticon-uicons/css/regular/all.css";
import "@flaticon/flaticon-uicons/css/solid/all.css";

import Colors from "@/styles/app.module.scss";
import i18n from "./i18n";

Vue.use(Vuetify);

export default new Vuetify({
  // Textos internos do Vuetify (tabelas, paginacao, date picker) no mesmo
  // idioma escolhido no Connect.
  lang: {
    locales: { pt, en },
    current: i18n.locale,
  },
  theme: {
    themes: {
      light: {
        ...Colors,
      },
      // Tema escuro do Connect (plugins/theme.js). Mesma paleta da marca, com
      // rosa e uva um pouco mais claros para o contraste sobre o fundo ameixa
      // de styles/theme.css; o "secondary" claro (lavanda) vira o tom escuro.
      dark: {
        ...Colors,
        primary: "#F2467F",
        secondary: "#2E1C3B",
        success: "#2FCF9F",
        error: "#F26B6B",
      },
    },
  },
});
